import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgDustinSymbol from '../../svg/dustin-symbol.svg'
import { IconProps } from '../icon-props'

const DustinSymbolIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgDustinSymbol
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-dustinsymbol', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default DustinSymbolIcon
